export default () => ({
  isMenuMinimized: false
})
